import React from "react";
import PropTypes from "prop-types";
import MardownParser from "react-markdown";

import MarkdownImage from "./MarkdownImage";
import MarkdownHeading from "./MarkdownHeading";
import * as TypeComponents from "../Type";

const renderers = {
  heading: MarkdownHeading,
  list: TypeComponents.UL,
  paragraph: TypeComponents.P,
  image: MarkdownImage
};

const Markdown = ({ source, html }) => {
  if (html) {
    return (
      <div
        className="blog-post-content"
        dangerouslySetInnerHTML={{ __html: html }}
      />
    );
  }
  return <MardownParser source={source} renderers={renderers} />;
};

Markdown.propTypes = {
  source: PropTypes.string.isRequired
};

export default Markdown;
